module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['widget', 'dof-tag-page-container', _vm.hasMargin && 'slider-margin'],
    attrs: {
      "weex-type": "div"
    }
  }, [_c('slider', {
    staticClass: "dof-tag-page-container-slider",
    attrs: {
      "infinite": _vm.infinite,
      "scrollable": _vm.scrollable,
      "index": _vm.sliderIndex,
      "data-evt-change": ""
    },
    nativeOn: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.sliderChange($event)
      }
    }
  }, [_vm._t("default", null, {})], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25f45694", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25f45694","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-tab-page-container/index.vue
// module id = 589
// module chunks = 0 1